module.exports = () => {
  return {
    data: null,
    error: false,
    handoffMode: '',
    orderMode: 'asap',
    selectedDay: null,
    selectedTime: null,
    asapUnavailable: null,
    deliveryStatus: null,
  }
}